module.exports = __webpack_public_path__ + "static/media/03-1-recption-.0d613828.webp";